export default __webpack_public_path__ + "static/media/bgAsideMb.d07ee6fb.png";